var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFooterCgv = function SvgIcFooterCgv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#767884",
    d: "M12 9.667V7.333a.666.666 0 0 0-.667-.666h-.666A3.35 3.35 0 0 0 11.433 2a3.347 3.347 0 0 0-4.653-.753c-.447.32-.807.753-1.047 1.24A3.323 3.323 0 0 0 1.147 3.58 3.333 3.333 0 0 0 2.24 8.167c.14.08.28.166.427.22V14a.667.667 0 0 0 .666.667h8A.667.667 0 0 0 12 14v-2.333l2.667 2.666V7zm-3.333-7a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666M4 4a1.333 1.333 0 1 1 0 2.667A1.333 1.333 0 0 1 4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIcFooterCgv;